import { ISuggestions } from '../../../../repositories/geo-suggest/entities/entities/Suggestions';
import { ISuggestItem } from '../../../../repositories/geo-suggest/entities/entities/SuggestItem';
import { ISuggestionGroup, IUndergroundDetails } from '../../../../types/suggestions';

export const SUGGESTION_TYPE_MAP: Record<string, string> = {
  company: 'builder',
  builder: 'builder',
  newbuilding: 'newobject',
  newbuildings: 'newobject',
  district: 'district',
  districts: 'district',
  underground: 'underground',
  undergrounds: 'underground',
};

export function extractSuggestion(suggestions: ISuggestions, type: keyof ISuggestions): ISuggestionGroup[] {
  const section = suggestions[type];
  const oneSection = (section && section.items) || [];
  const isNewbuildingsType = type === 'newbuildings';

  return oneSection.map(item => {
    const suggestItem = item as ISuggestItem;
    const itemName = isNewbuildingsType ? `ЖК «${suggestItem.name}»` : suggestItem.name;

    return {
      title: itemName,
      displayName: itemName,
      type: SUGGESTION_TYPE_MAP[suggestItem.type],
      value: String(suggestItem.id),
      dataType: 'simple',
      url: suggestItem.link || undefined,
      fullAddress: suggestItem.address || undefined,
      undergroundLines: (suggestItem.lines as IUndergroundDetails[]) || undefined,
    };
  });
}
